import { Mail, Monitor, Smartphone } from '../../../icons';
import { PendingRow } from '../PendingRow';
import { useMenuConfig } from '../../../lib/menu-config';
import { tSettings } from '../../../lib/settings-i18n';
import { tLayout } from '../../../lib/layout-i18n';

/**
 * 알림 채널 · 화면별 알림 (2026-08-20 하위 메뉴 분리).
 *
 * 원래 `NotificationsPanel` 의 뒤쪽 두 블록이다. **화면별 알림은 등록된 메뉴 수만큼 행이
 * 늘어나서**, 한 화면에 두면 그 위의 알림 종류·외부 연동이 스크롤 밖으로 밀렸다. 그래서
 * "어디로 받을지"(채널·화면)를 따로 뗐다. 목록의 진실원은 메뉴 레지스트리(useMenuConfig)이고,
 * 못 읽어오면 기본 5개로 떨어지는 것도 종전과 같다.
 */

const FALLBACK_SCREENS: ReadonlyArray<string> = [
  'layout.nav.dashboard', 'layout.nav.chat', 'layout.nav.mail', 'layout.nav.calendar', 'layout.nav.task',
];

export function NotifChannelsPanel() {
  const { rows } = useMenuConfig();
  const screens = rows && rows.length > 0
    ? rows.map((r) => ({ key: r.menu_key, label: r.label }))
    : FALLBACK_SCREENS.map((k) => ({ key: k, label: tLayout(k) }));

  return (
    <>
      <section className="settings-section" aria-labelledby="st-notif-h2">
        <h2 id="st-notif-h2">{tSettings('settings.modal.notif.channel')}</h2>
        <p className="settings-section-subtitle">{tSettings('settings.modal.notif.desc')}</p>

        <div className="st-rows">
          <PendingRow
            icon={<Monitor size={15} />}
            title={tSettings('settings.modal.notif.pc')}
            desc={tSettings('settings.modal.notif.pc_desc')}
          />
          <PendingRow
            icon={<Smartphone size={15} />}
            title={tSettings('settings.modal.notif.mobile')}
            desc={tSettings('settings.modal.notif.mobile_desc')}
          />
          <PendingRow
            icon={<Mail size={15} />}
            title={tSettings('settings.modal.notif.mail')}
            desc={tSettings('settings.modal.notif.mail_desc')}
          />
        </div>
      </section>

      <section className="settings-section" aria-labelledby="st-notif-screens-h2">
        <h2 id="st-notif-screens-h2">{tSettings('settings.modal.notif.by_screen')}</h2>
        <p className="settings-section-subtitle">{tSettings('settings.modal.notif.by_screen_desc')}</p>

        <div className="st-rows">
          {screens.map((s) => (
            <PendingRow key={s.key} title={s.label} desc={tSettings('settings.modal.notif.row_desc')} />
          ))}
        </div>
      </section>
    </>
  );
}
